import angular from 'angular';

import {} from './od-facebook-share-button.less';

module.exports = angular.module('market.components.od-facebook-share-button', [])
.component('odFacebookShareButton', {
  bindings: {
    href: '@',
    title: '@',
    description: '@',
    picture: '@',
    caption: '@',
    blue: '<?',
  },
  template: require('./od-facebook-share-button.jade')(),
  controller: class {
    constructor(Facebook) {
      this.Facebook = Facebook;
      if (typeof(this.blue) === 'undefined') {
        this.blue = true;
      }
    }

    share() {
      this.Facebook.share({
        href: this.href,
        title: this.title,
        description: this.description,
        picture: this.picture,
        caption: this.caption,
      });
    }
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-facebook-share-button.js
 **/